<template>
  <div class="region-container">
    <at-input v-model="search" type="search" placeholder="Район..." prepend>
      <template slot="prepend">
        <i class="icon icon-search"></i>
      </template>
    </at-input>
    <div class="region-content" id="reglist">
      <div v-for="option in options" :key="option.id" style="margin-left: 6px" :id="`reg_${option.id}`">
        <at-checkbox v-model="option.selected" :label="option.id" @on-change="() => {select(option)}">
          {{ option.label }}
        </at-checkbox>
      </div>
    </div>
    <div class="region-footer">
      <at-button type="text" style="width: 50%" @click="selectAll(true)">Выбрать все</at-button>
      <at-button type="text" style="width: 50%" @click="selectAll(false)">Снять выбор</at-button>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    options() {
      if (this.search != '')
        return this.$store.state.regions.filter.filter(reg => reg.label.toLowerCase().includes(this.search.toLowerCase()))
      else
        return this.$store.state.regions.filter
    }
  },
  data: () => ({
      search: ''
  }),
  methods: {
    select(reg) {
      var option = (!reg.selected)?'default':'selected'
      window.borderManager.objects.setObjectOptions(reg.id, Object.assign({}, this.$store.state.regions.borders.style[option]))
    },
    selectAll(val) {
      this.$store.state.regions.filter.forEach(reg => {
        reg.selected = val
        this.select(reg)
      })
    }
  }
}
</script>

<style>
.region-container {
    border: 1px solid #dfdfdf; 
    border-radius: 4px;
}
.region-content {
    height: calc(50vh - 158px); 
    overflow-y: auto; 
    overflow-x: hidden;
    scroll-behavior: smooth
}
.region-container input, 
.region-container input:focus, 
.region-container input:hover {
  border: 0;
  border-bottom: 1px solid #dfdfdf;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.region-container .at-btn:focus {
  outline: 0 !important;
}
.region-container .at-input-group__prepend {
  border: 0 !important;
  border-bottom: 1px solid #dfdfdf !important;
  border-bottom-right-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.region-footer {
  border-top: 1px solid #dfdfdf;
}
</style>